@if (readyToDownload) {
  <ng-container *ngTemplateOutlet="loadedTemplate"></ng-container>
} @else {
  Loading&hellip;
}
